import React from "react";
import { ClerkProvider } from "@clerk/clerk-react";

const PUBLISHABLE_KEY = process.env.GATSBY_CLERK_PUBLISHABLE_KEY;

export default function ClerkWrapper({ children }: { children: React.ReactNode }) {
  if (!PUBLISHABLE_KEY) {
    throw new Error('Missing Clerk publishable key');
  }
  // detect SSR
  if (typeof window === "undefined") {
    return (
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} signInUrl="/sign-in">
        {children}
      </ClerkProvider>
    );
  }

  // client-side dedupe guard
  // @ts-ignore
  if ((window as any).__CLERK_PROVIDER_MOUNTED) {
    // already mounted elsewhere — just return children
    return <>{children}</>;
  }

  // mark as mounted and render provider once
  // @ts-ignore
  (window as any).__CLERK_PROVIDER_MOUNTED = true;

  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} signInUrl="/sign-in">
      {children}
    </ClerkProvider>
  );
}